import React from "react";
import { Popup } from "semantic-ui-react";

const UpcomingOrdersPopup = ({ upcomingOrders = [] }) => {
  if (!upcomingOrders.length) return null;
  return (
    <Popup
      trigger={<span className="note" />}
      position="top center"
      flowing
      hoverable
      style={{ padding: 7 }}
    >
      <div style={{ minWidth: "110px", padding: 0, margin: 0 }}>
        {/* Header */}
        <div
          style={{
            display: "flex",
            padding: "8px",
            backgroundColor: "#f0f0f0",
            fontWeight: "600",
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
            margin: 0,
          }}
        >
          <p style={{ margin: 0 }}>Upcoming ({upcomingOrders.length})</p>
        </div>

        {/* Body */}
        <div
          style={{
            maxHeight: "225px",
            overflowY: "auto",
            border: "1px solid #ddd",
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px",
            padding: 0,
            margin: 0,
          }}
        >
          {upcomingOrders.map((order, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                padding: "8px",
                borderBottom: "1px solid #eee",
                backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                margin: 0,
              }}
            >
              {order.unit_number} - {order.service_code}
            </div>
          ))}
        </div>
      </div>
    </Popup>
  );
};

export default UpcomingOrdersPopup;
